import React from "react";
import { useOutlet } from "react-router-dom";
import { LoadingPage } from "@/components/LoadingPage/LoadingPage";
import { Navigation } from "@/components/Navigation/Navigation";
import { PageHelmet } from "@/components/PageHelmet/PageHelmet";
import { useAppData } from "@/hooks/useAppData";

export const AdminDashboardLayout = () => {
    const outlet = useOutlet();
    const { isLoading: isAppDataLoading } = useAppData();

    if (isAppDataLoading) {
        return <LoadingPage />;
    }

    return (
        <React.Fragment>
            <PageHelmet
                title="Admin"
                robotsOverride="noindex, nofollow"
            />
            <div className="relative bg-neutral-50">
                <Navigation />
                <div className="mt-10 min-h-[calc(100vh-100px)] bg-white pb-8">
                    {outlet}
                </div>
            </div>
        </React.Fragment>
    );
};
